module.exports = __webpack_public_path__ + "static/01-db294c1e4ce1ba527641c9cdfe7e354b.jpg";